const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

let csrfToken = null;

export const fetchCsrfToken = async () => {
    try {
        const res = await fetch(`${API_BASE}/api/csrf-token`);
        if (res.ok) {
            const data = await res.json();
            csrfToken = data.csrf_token;
            console.log("CSRF Token initialized");
        }
    } catch (err) {
        console.warn("Failed to fetch CSRF token - backend might not have CSRF enabled yet", err);
    }
};

export const getCsrfToken = () => csrfToken;

/**
 * Wrapper for fetch that adds Authorization and CSRF headers.
 * @param {string} endpoint - API endpoint (e.g., '/api/materials') or full URL
 * @param {object} options - Fetch options
 * @returns {Promise<Response>}
 */
export const authenticatedFetch = async (endpoint, options = {}) => {
    const token = localStorage.getItem('token');

    // Default headers
    const headers = {
        ...options.headers,
    };

    // Ensure Content-Type is JSON unless likely FormData (no content-type set)
    if (!headers['Content-Type'] && !(options.body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }

    // Add Auth Token
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    // Add CSRF Token for state-changing requests
    const method = (options.method || 'GET').toUpperCase();
    if (csrfToken && ['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
        headers['X-CSRF-Token'] = csrfToken;
    }

    const url = endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`;

    return fetch(url, {
        ...options,
        headers,
    });
};
